export const getSpecificObjectsData = async ({ derivativeId, accessToken, guid, queryBody }) => {
    if (!accessToken || !derivativeId || !guid || !queryBody) {
        throw new Error('Missing required parameters for fetching item metadata');
    }

    let mergedData = {
        pagination: {},
        data: {
            type: "properties",
            collection: []
        }
    };

    const prefixes = queryBody.query.$prefix;
    // console.log('Original prefixes from queryBody:', prefixes);

    for (const prefix of prefixes[1]) { // Iterate over the values inside the array (e.g., "ACP", "SLINE")
        let hasMoreData = true;
        let offset = 0;
        const limit = queryBody.pagination.limit;

        while (hasMoreData) {
            // Update the pagination offset and prefix in the queryBody
            const currentQueryBody = {
                ...queryBody,
                pagination: {
                    ...queryBody.pagination,
                    offset: offset
                },
                query: {
                    ...queryBody.query,
                    $prefix: [prefixes[0], prefix] // Correctly use "name" and the current prefix value
                }
            };

            // console.log('Current queryBody being used:', currentQueryBody);

            // Prepare the request headers
            const requestHeaders = new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            });

            // Prepare the request object
            const request = new Request(`https://developer.api.autodesk.com/modelderivative/v2/regions/eu/designdata/${derivativeId}/metadata/${guid}/properties:query`, {
                method: 'POST',
                headers: requestHeaders,
                body: JSON.stringify(currentQueryBody)
            });

            try {
                // Fetch attempt
                let response = await fetch(request);

                // Handle 404 error with "No objects found" message gracefully
                if (response.status === 404) {
                    let errorData = await response.json();
                    if (errorData.diagnostic === "No objects found") {
                        console.log(`No records found for prefix: ${prefix}`);
                        break;
                    } else {
                        console.error(`Unexpected 404 error: ${response.statusText}`);
                        break;
                    }
                }

                // Check if the response is okay
                if (!response.ok) {
                    console.error(`HTTP error from fetching specific object data! Status: ${response.status} ${response.statusText}`);
                    break;
                }

                let objectData = await response.json();

                // Ensure pagination and data exist before trying to access totalResults
                if (!objectData.pagination || !objectData.data) {
                    console.log(`No records found for prefix: ${prefix}`);
                    break;
                }

                // console.log('Fetched specific object data:', objectData);

                // Merge the fetched data into mergedData if collection is not empty
                if (objectData.data.collection && objectData.data.collection.length > 0) {
                    mergedData.data.collection.push(...objectData.data.collection);
                }

                // Update pagination information if collection is not empty
                if (objectData.data.collection && objectData.data.collection.length > 0) {
                    mergedData.pagination = objectData.pagination;
                }

                // Update the offset for the next iteration
                offset += limit;

                // Check if there's more data to fetch
                if (offset >= objectData.pagination.totalResults) {
                    hasMoreData = false;
                }

            } catch (error) {
                // Log the error but do not throw to avoid breaking the loop
                console.error('Error from fetching specific object data:', error);
                break;
            }
        }
    }

    return mergedData;
};